/* eslint-disable */
export const NAV_MAP: Record<string, string> = {
  // 'nav.dashboard': '/dashboard',
  // 'nav.dao': '/dao',
  'nav.vesting': '/vesting',
};

export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
  BSC_TESTNET = 97,
  XDAI = 100,
}

export const SupportedChainId = [100, 4]; // xdai and rinkeby

export const RICE: any = {
  [ChainId.XDAI]: '0x97edc0e345fbbbd8460847fcfa3bc2a13bf8641f',
  [ChainId.RINKEBY]: '0x3291548496A243096d8BB0Bd980369727d8dFA32',
};

// tt0
export const WXDAI: any = {
  [ChainId.XDAI]: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
  [ChainId.RINKEBY]: '0x3291548496A243096d8BB0Bd980369727d8dFA32',
};

export const STREAM: any = {
  [ChainId.XDAI]: '0x437140f0cEfC6EF743F4453868311f35D313994f',
  [ChainId.RINKEBY]: '0x2d5D6dC671Fa134304C1741afb292bF6d2679018',
};

export const NFTS: any = {
  [ChainId.XDAI]: '0x70f3Be3f01cfaEF5EF08a493E43425cFab3c8A4E',
  [ChainId.RINKEBY]: '0xF4E7FBA05BedD5f456c5bCC529B1DcD74688b0a4',
};

export const TOKEN_ADDRESS: { [key: string]: any } = {
  WXDAI,
  RICE,
};

export const tokenMap: any = {
  '0x524a71eaafc549cbdf2013a9f9a7a356a9e54372': {
    token: 'VTT',
    imgUrl: 'https://daodkp.oss-ap-southeast-1.aliyuncs.com/assets/logo-sm.png',
    name: 'V test token vesting',
  },
  '0xdde9d08afd81350bfcdc7d51c1b22455a5b93b14': {
    token: 'JTT',
    imgUrl: 'https://daodkp.oss-ap-southeast-1.aliyuncs.com/assets/logo-sm.png',
    name: 'J test token vesting',
  },
  '0x97edc0e345fbbbd8460847fcfa3bc2a13bf8641f': {
    token: 'RICE',
    imgUrl: 'https://daodkp.oss-ap-southeast-1.aliyuncs.com/assets/logo-sm.png',
    name: 'RICE',
  },
};

export const POINT_PRECISION = 100000000;
export const TOKEN_PERCISION = 1000000000000000000;
// approve amount 1b
export const APPROVE_LIMIT = '100000000000000000000000000';

// switch network
export const CHAIN_CONFIGS = {
  100: {
    id: '1',
    jsonrpc: '2.0',
    method: 'wallet_addEthereumChain',
    params: [
      {
        chainId: '0x64',
        chainName: 'Genosis',
        rpcUrls: ['https://dai.poa.network'],
        blockExplorerUrls: ['https://blockscout.com/poa/xdai'],
        nativeCurrency: {
          name: 'xDai',
          symbol: 'XDAI',
          decimals: 18,
        },
      },
    ],
  },
  // 4: {
  //   id: '1',
  //   jsonrpc: '2.0',
  //   method: 'wallet_addEthereumChain',
  //   params: [
  //     {
  //       chainId: '0x4',
  //       chainName: 'Rinkeby',
  //       rpcUrls: ['https://rinkeby.infura.io/v3/6c3a011449f34ccdaaaddfc504d2e1e1'],
  //       blockExplorerUrls: ['https://rinkeby.etherscan.io'],
  //       nativeCurrency: {
  //         name: 'Rinkeby',
  //         symbol: 'ETH',
  //         decimals: 18,
  //       },
  //     },
  //   ],
  // },
  4: {
    id: '1',
    jsonrpc: '2.0',
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: '0x4' }],
  },
};
